export const SUSTAINED_NOTE_DURATION = 8; // IN SECONDS
export const NON_SUSTAINED_NOTE_DURATION = 1.5; // IN SECONDS
export const ASSETS_PATH = "public";
export const INSTRUMENT_URL = "/acoustic_grand_piano-mp3.js";
